
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ClassificationOfGoiter',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/ClassificationOfGoiter.vue